




























import { Vue, Component } from "vue-property-decorator";
@Component({
  components: {
    "client-templates-slots-provider": () =>
      import("@/components/app/admin/clientTemplates/slotsProvider.vue"),
    "client-templates-slots-listing": () =>
      import("@/components/app/admin/clientTemplates/slotsListing.vue")
  }
})
export default class AdminClientTemplatesSlots extends Vue {}
